var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel-loading"},[_c('Spinner',{attrs:{"with-overlay":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }